import { render, staticRenderFns } from "./tpeSection.vue?vue&type=template&id=37d0f2b0&scoped=true&"
import script from "./tpeSection.vue?vue&type=script&lang=js&"
export * from "./tpeSection.vue?vue&type=script&lang=js&"
import style0 from "./tpeSection.vue?vue&type=style&index=0&id=37d0f2b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0f2b0",
  null
  
)

export default component.exports